import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  blockListParams,
  blockListQueryOptions,
  blockListSearchSchema,
  BlocksPage,
} from '@/features/content';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blocks/')({
  staticData: { tours: ['content.blocks'] },
  // Typed as the raw input so links into the list (`<Link to=".../content/blocks">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    blockListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...blockListQueryOptions(params.storeId, blockListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: BlocksPage,
});
